import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import neighborhoodStreetIntersectionReadAction from './neighborhoodStreetIntersectionRead.action.json' assert { type: 'json' }

const neighborhoodStreetIntersectionReadDefinition = defineReadAutoAction(
  neighborhoodStreetIntersectionReadAction,
  'neighborhoodStreetIntersection',
)

export default neighborhoodStreetIntersectionReadDefinition
